import { Provider } from '@repo/api-gw-sdk';

const SupportedAWSRegions = [
  'us-east-1',
  'us-east-2',
  'us-west-1',
  'us-west-2',
  'ca-central-1',
  'eu-west-1',
  'eu-west-2',
  'eu-west-3',
  'eu-north-1',
  'eu-central-1',
];

const SupportedAzureRegions = [
  'eastus',
  'eastus2',
  'centralus',
  'northcentralus',
  'southcentralus',
  'westus',
  'westus2',
  'westus3',
  'westcentralus',
  'canadacentral',
  'canadaeast',
  'westeurope',
  'northeurope',
  'australiacentral',
  'australiaeast',
  'australiasoutheast',
  'francecentral',
  'germanywestcentral',
  'japaneast',
  'japanwest',
  'swedencentral',
  'uksouth',
  'ukwest',
  'centralindia',
  'westindia',
  'southindia',
];

const SupportedGCPRegions = [
  'us-east1',
  'us-central1',
  'us-east4',
  'us-west1',
  'us-west2',
  'us-west3',
  'us-west4',
  'us-east5',
  'us-south1',
  'northamerica-northeast1',
  'northamerica-northeast2',
  'northamerica-south1',
  'europe-west1',
  'europe-west2',
  'europe-west3',
  'europe-west4',
  'europe-west6',
  'europe-west8',
  'europe-west9',
  'europe-west10',
  'europe-west12',
  'europe-north1',
  'europe-north2',
  'europe-southwest1',
  'europe-central2',
  'asia-east1',
  'asia-southeast1',
  'asia-south1',
  'asia-northeast1',
  'australia-southeast1',
  'australia-southeast2',
  'southamerica-east1',
  'southamerica-west1',
];

export const useSupportedRegions = (): Partial<Record<Provider, string[]>> => {
  return {
    [Provider.Aws]: SupportedAWSRegions,
    [Provider.Azure]: SupportedAzureRegions,
    [Provider.Gcp]: SupportedGCPRegions,
  };
};
